module.exports = __webpack_public_path__ + "a2314fc9/img/cadBim.e369a02a.png";